import { render, staticRenderFns } from "./Pairs.vue?vue&type=template&id=bffaafd8&scoped=true&"
import script from "./Pairs.vue?vue&type=script&lang=js&"
export * from "./Pairs.vue?vue&type=script&lang=js&"
import style0 from "./Pairs.vue?vue&type=style&index=0&id=bffaafd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffaafd8",
  null
  
)

export default component.exports